import theme from '../../../lib/theme';
import { NavigationBlockProps } from './NavigationBlock';

const {
  scale,
  layouts,
  colors,
  media,
  font: {
    families,
    heights,

    ...font
  },
} = theme;

export default ({ collapsed, breadcrumbs = [] }: NavigationBlockProps) => ({
  topContainer: {
    ...layouts.column,

    // borderBottom: `1px solid ${colors.grey}`,
    alignItems: 'center',
    padding: `0 ${scale.xs}`,

    [media.s.up]: {
      padding: `0 ${scale.s}`,
    },
  },

  bottomContainer: {
    ...layouts.column,

    borderBottom: `1px solid ${colors.grey}`,
    alignItems: 'center',
    padding: `0 ${scale.xs}`,

    [media.s.up]: {
      padding: `0 ${scale.s}`,
    },
  },

  subtitle: {
    fontWeight: `${font.normal} !important`,
  },

  breadcrumbs: {
    fontFamily: families.primary,
    fontWeight: font.normal,
    fontSize: font.m,
    lineHeight: heights.m,
    margin: 0,

    '& a': {
      color: colors.sas.primary,
      textDecoration: 'none !important',
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',
    },

    '& a:hover': {
      textDecoration: 'underline !important',
      textTransform: 'capitalize',
    },

    [media.m.up]: {
      fontSize: font.xl,
      lineHeight: heights.xl,
    },
  },

  breadcrumbSep: {
    color: breadcrumbs.length === 1 ? colors.sas.primary : colors.grey,
    verticalAlign: 'middle',
  },

  title: {
    fontSize: `${font.xxxxl} !important`,
    lineHeight: `${heights.xxxxl} !important`,

    [media.s.down]: {
      fontSize: `${font.xxxl} !important`,
      lineHeight: `${heights.xxxl} !important`,
    },
  },

  links: {
    ...layouts.column,

    maxHeight: collapsed ? 0 : 2000,
    overflow: 'hidden',
    paddingTop: !collapsed ? scale.s : undefined,
    flexWrap: 'wrap',
    transition: 'max-height 350ms ease',

    [media.s.up]: {
      ...layouts.row,

      maxHeight: 2000,
      paddingTop: scale.s,
    },

    '& > *': {
      marginRight: scale.m,
      marginBottom: scale.s,
    },

    '& > *:last-child': {
      marginRight: 0,
    },
  },

  toggle: {
    cursor: 'pointer',
    marginTop: scale.s,
    marginBottom: collapsed ? scale.s : 0,

    [media.s.up]: {
      display: 'none',
    },
  },

  link: {
    cursor: 'pointer',
    fontSize: font.l,
    lineHeight: heights.l,
    fontWeight: font.bold,
    textDecoration: 'none !important',
    transition: 'all 150ms linear',

    '&:hover': {
      color: colors.sas.secondary,
      textDecoration: 'underline !important',
    },
  },

  childLinks: {
    ...layouts.column,

    maxHeight: collapsed ? 0 : 2000,
    overflow: 'hidden',
    flexWrap: 'wrap',
    transition: 'max-height 350ms ease',

    [media.s.up]: {
      ...layouts.row,

      maxHeight: 2000,
    },

    '& > *': {
      marginRight: scale.m,
      marginBottom: scale.s,
    },

    '& > *:last-child': {
      marginRight: 0,
    },
  },

  childLink: {
    fontSize: font.m,
    lineHeight: heights.m,
    fontFamily: families.primary,
    color: colors.sas.primary,
    textDecoration: 'none',
    transition: 'all 150ms linear',

    '&:hover': {
      color: colors.sas.secondary,
      textDecoration: 'underline',
    },
  },
});
